export default __webpack_public_path__ + "static/media/icon-appointment-pending.8ff0bdfe.svg";